import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const AnagraficheConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/anagrafiche/mandatari',
      component: FuseLoadable({
        loader: () => import('./ListaMandatari')
      })
    },
    {
      path: '/anagrafiche/backendEntita/:id?',
      component: FuseLoadable({
        loader: () => import('./ListaBackendEntita')
      })
    }
  ]
}
